import React from "react";
import Icon from "../../../../components/Icon";
import { Wave } from "../../../../components/Wave";
import HouseCircularButton from "../HouseCircularButton/HouseCircularButton";
import { useModal, useWindowResize } from "../../../../hooks";
import HouseModal from "./HouseModal/HouseModal";
import ThingsModal from "./ThingsModal/ThingsModal";
import HouseThingsModal from "./HouseThingsModal/HouseThingsModal";
import "./styles.css";
import Datalayer from "../../../../libs/vendors/data-layer";
import { CLICK_ACTIONS, MODAL_NAMES, MODAL_TYPES } from "../../../../constants/datalayer";
import houseDesktopIcon from '../../../../assets/images/icons/house.svg'
import houseMobileIcon from '../../../../assets/images/icons/house-mobile.svg'
const WhichEnsureSection = () => {
    const { isMobile } = useWindowResize();
    const houseIcon = !isMobile ? "house" : "house-mobile";
    const houseIconImage = !isMobile ? houseDesktopIcon : houseMobileIcon;
    const [isOpenHouse, toggleModalHouse] = useModal();
    const [isOpenThings, toggleModalThings] = useModal();
    const [isOpenHouseThings, toggleModalHouseThings] = useModal();

    const onToggleModalThings = (includeCloseTag = 1) => {
        const modalName = `${MODAL_NAMES.COVERAGE_TYPES}: Cosas`;

        if (isOpenThings) {
            if (includeCloseTag)
                Datalayer.sendModal(
                    MODAL_TYPES.INFO,
                    modalName,
                    CLICK_ACTIONS.CLOSE_MODAL
                );
        } else {
            Datalayer.sendModal(MODAL_TYPES.INFO, modalName);
        }

        toggleModalThings();
    };

    const onToggleModalHouseThings = (includeCloseTag = 1) => {
        const modalName = `${MODAL_NAMES.COVERAGE_TYPES}: Casa + Cosas`;

        if (isOpenHouseThings) {
            if (includeCloseTag)
                Datalayer.sendModal(
                    MODAL_TYPES.INFO,
                    modalName,
                    CLICK_ACTIONS.CLOSE_MODAL
                );
        } else {
            Datalayer.sendModal(MODAL_TYPES.INFO, modalName);
        }

        toggleModalHouseThings();
    };

    const onToggleModalHouse = (includeCloseTag = 1) => {
        const modalName = `${MODAL_NAMES.COVERAGE_TYPES}: Casa`;

        if (isOpenHouse) {
            if (includeCloseTag)
                Datalayer.sendModal(
                    MODAL_TYPES.INFO,
                    modalName,
                    CLICK_ACTIONS.CLOSE_MODAL
                );
        } else {
            Datalayer.sendModal(MODAL_TYPES.INFO, modalName);
        }

        toggleModalHouse();
    };

    return (
        <>
            <Wave color="#f6f8fb" flip />
            <section className="landing-which-ensure">
                <div className="landing-which-ensure__title">
                    <span>Averigua qué puedes proteger en </span>
                    <br />
                    <span>tu casa o departamento</span>
                </div>
                <span className="landing-which-ensure__header-house">
                    Dale clic a la casa y descúbrelo
                </span>
                <div className="landing-which-ensure__house">
                    <Icon name={houseIcon} image={houseIconImage} />
                    <div className="landing-which-ensure__things">
                        <HouseCircularButton
                            text="2"
                            handleOnClick={onToggleModalThings}
                        />
                    </div>
                    <div className="landing-which-ensure__things-houses">
                        <HouseCircularButton
                            text="3"
                            handleOnClick={onToggleModalHouseThings}
                        />
                    </div>
                    <div className="landing-which-ensure__houses">
                        <HouseCircularButton
                            text="1"
                            handleOnClick={onToggleModalHouse}
                        />
                    </div>
                </div>
                <HouseModal show={isOpenHouse} handleOnClose={onToggleModalHouse} />
                <ThingsModal show={isOpenThings} handleOnClose={onToggleModalThings} />
                <HouseThingsModal
                    show={isOpenHouseThings}
                    handleOnClose={onToggleModalHouseThings}
                />
            </section>
        </>
    );
};

export default React.memo(WhichEnsureSection);
